module.exports = __webpack_public_path__ + "img/93.13b4ab8d.jpg";